(function(){
  $.each($('.utility_slider'), function(){
    runSlider($(this));
  })

  function runSlider(utilitySlider){
    var config = {
      useTransform: true,
      useCSS: true,
      vertical:true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: -1,
      autoplay: true,
      speed: 0,
      autoplaySpeed: 5000,
      arrows: true,
      prevArrow: '<button class="lnr lnr-chevron-left animation left-arrow" aria-label="Previous"></button>',
      nextArrow: '<button class="lnr lnr-chevron-right animation right-arrow" aria-label="Next"></button>'
    };
    if(utilitySlider.closest('.header-drop').length > 0){
      config.prevArrow = '<i class="lnr lnr-chevron-left animation left-arrow"></i>';
      config.nextArrow = '<i class="lnr lnr-chevron-right animation right-arrow"></i>';
      config.accessibility = false;
    }
    utilitySlider.slick(config);

    utilitySlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      utilitySlider.find('[data-slick-index="'+currentSlide+'"] .animated').removeClass('bounceInDown').addClass('invisible');
      utilitySlider.find('[data-slick-index="'+nextSlide+'"] .animated').removeClass('invisible').addClass('bounceInDown');
    });
  }
}())